import { render, staticRenderFns } from "./RejectionHistory.vue?vue&type=template&id=4e40566c&scoped=true"
import script from "./RejectionHistory.vue?vue&type=script&lang=js"
export * from "./RejectionHistory.vue?vue&type=script&lang=js"
import style0 from "./RejectionHistory.vue?vue&type=style&index=0&id=4e40566c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e40566c",
  null
  
)

export default component.exports